import React from 'react';
import PropTypes from 'prop-types';

const SliderButton = props => (
  <button
    type="button"
    onClick={props.onClick}
    className={`slideshow-button slick-arrow slick-${props.direction}`}
  >
    <i
      className={`fa fa-${
        props.direction === 'prev' ? 'angle-left' : 'angle-right'
      }`}
    />
  </button>
);

SliderButton.propTypes = {
  onClick: PropTypes.func,
  direction: PropTypes.string.isRequired
};

SliderButton.defaultProps = {
  onClick: {}
};

export default SliderButton;
